import { render, staticRenderFns } from "./console-page.vue?vue&type=template&id=23d9eee8"
import script from "./console-page.vue?vue&type=script&lang=js"
export * from "./console-page.vue?vue&type=script&lang=js"
import style0 from "./console-page.vue?vue&type=style&index=0&id=23d9eee8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports